import React from "react";

import CollectionName from "../../molecules/collection-name";
import SecVideoSelector from "../../molecules/secvideo-selector";
import StoryCard10 from "../../molecules/story-card10";
import Separator from "../../atoms/separator";
import PartialCarousel from "../../atoms/carousel-partial";

import "./video-slider.m.css";

const MobileVideoSlider = ({ allStories, collection, selectItem, VideosCollections }) => {
  const stories = allStories.splice(1, 7);
  return (
    <>
      <CollectionName collection={collection} isSeeMore={false} />
      <div styleName="border-wrapper">
        <SecVideoSelector selectItem={selectItem} VideosCollections={VideosCollections} />
        <div styleName="wrapper">
          <StoryCard10 story={allStories[0]} showDate={false} />
          <div styleName="carousel-wrapper">
            <PartialCarousel length={stories.length}>
              {stories.map((item, index) => (
                <StoryCard10 story={item} key={index} />
              ))}
            </PartialCarousel>
          </div>
        </div>
        <Separator />
      </div>
    </>
  );
};

export default MobileVideoSlider;
